// src/tenant-products/types.ts
var TENANT_STORE_KEY = "tenant-store:v1";
var TENANT_STORE_VERSION = 1;
var TENANT_PRODUCT_DATA_VERSION = 1;
function emptyProductDataBag() {
  return {
    v: TENANT_PRODUCT_DATA_VERSION,
    hubs: {},
    entities: {},
    preferences: {},
    legacy: {},
    extensions: {}
  };
}
function emptyTenantStore() {
  return {
    v: TENANT_STORE_VERSION,
    catalog: [],
    products: {},
    meta: {}
  };
}

export {
  TENANT_STORE_KEY,
  TENANT_STORE_VERSION,
  TENANT_PRODUCT_DATA_VERSION,
  emptyProductDataBag,
  emptyTenantStore
};
